





























































































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import Modal from '@components/Modal'
import RadioGroup from '@ui/AudienceSetWizard/components/RadioGroup'
import StepContainer from '@ui/AudienceSetWizard/StepContainer'
import PartnershipSteps from '@ui/AudienceSetWizard/PartnershipStep/PartnershipSteps'
import BrandSelector from '@ui/AudienceSetWizard/components/BrandSelector'
import AudienceAvailabilitySelector from '@ui/AudienceSetWizard/components/AudienceAvailabilitySelector'
import TreeSelector from '@ui/TreeSelector'

settings =
  name: 'PartnershipCatexStep'

  vue:
    props: ['wizard', 'step']
    mixins: [WizardService.step()]

    components: {
      Modal,
      RadioGroup,
      StepContainer,
      PartnershipSteps,
      BrandSelector,
      AudienceAvailabilitySelector,
      TreeSelector,
    }

    data: ->
      catexModal:
        show: false
        mode: 'create'
        categories: []
        sponsor: {}
        availabilityKeys: []

    computed:
      audienceAvailabilities: -> @wizard.audienceSetData.audience_availabilities

      listingTypes: -> @$store.marketplace.listing.types

      brandInitialValue: -> @catexModal.categories
      brandCategoriesOptions: ->
        mapping = @marketplace?.brand?.categories || {}
        tree = @marketplace?.brand?.category_tree || {}
        tree.other ||= "Other" # auto add as a top level category
        @jsonToElementUICascader tree, mapping
      brandCategoriesActions: ->
        select: @selectBrandCategories

      catexTableData: ->
        tableData = {}
        for audienceAvailability in @audienceAvailabilities
          for category, sponsor of audienceAvailability.restrictions.catex.exclusive
            key = "#{category}.#{sponsor.domain}"
            tableData[key] ||= { id: key, category, sponsor, availabilities: [] }
            tableData[key].availabilities.push audienceAvailability
        Object.values tableData

    methods:
      hiAddNewCategory: ->
        @catexModal.show = true

      hiCloseCatexModal: ->
        @closeSponsorModal()

      hiSaveCatexModal: ->
        { categories, sponsor, availabilityKeys } = @catexModal
        for audienceAvailability in @audienceAvailabilities
          category = categories[categories.length - 1]
          if audienceAvailability.key in availabilityKeys
            audienceAvailability.restrictions.catex.exclusive[category] = sponsor
          else
            delete audienceAvailability.restrictions.catex.exclusive[category]
        @wizard.syncAndSave()
        @closeSponsorModal()

      hiRemoveCatex: (catex) ->
        { category, sponsors, availabilities } = catex
        for audienceAvailability in availabilities
          delete audienceAvailability.restrictions.catex.exclusive[category]
        @wizard.syncAndSave()

      hiEditCatex: (catex) ->
        { category, sponsor, availabilities } = catex
        @catexModal =
          show: true
          mode: 'edit'
          categories: [category]
          sponsor: sponsor
          availabilityKeys: availabilities.map((av) -> av.key)

      closeSponsorModal: ->
        @catexModal =
          show: false
          mode: 'create'
          categories: []
          sponsor: {}
          availabilityKeys: []

      imageForAvailability: (audienceAvailability) ->
        audienceAvailability.images?[0]

      selectBrandCategories: (categories) ->
        @catexModal.categories = [...categories]

export default VueOptions.vue settings
